import { render, staticRenderFns } from "./depositDetails.vue?vue&type=template&id=37a5b650&scoped=true&"
import script from "./depositDetails.vue?vue&type=script&lang=js&"
export * from "./depositDetails.vue?vue&type=script&lang=js&"
import style0 from "./depositDetails.vue?vue&type=style&index=0&id=37a5b650&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a5b650",
  null
  
)

export default component.exports